import React from "react"
import { mapSdk } from "../../model/base";

import { initMap } from "./wdfunction";


export default class CarMapLocation extends React.Component {
    constructor(props) {
        super(props);

    
    }

    componentDidMount() {
        if (this.props.location) {
            this.initMap(this.refs, this.props.location.lat, this.props.location.lng);
        }
    }

    // componentWillUpdate(props) {
    //     if (props.address === "" || this.props.location.lat !== props.location.lat || this.props.location.lng !== props.location.lng) {
    //         this.pMarker && this.pMarker.setMap(null);
    //         if (props.address !== "") {
    //             const pos = new window.google.maps.LatLng(props.location.lat, props.location.lng);
    //             this.pMarker = new window.google.maps.Marker({
    //                 icon: {
    //                     url: props.icon ? props.icon : car_icon,
    //                     scaledSize: new window.google.maps.Size(34, 44)
    //                 },
    //                 position: pos,
    //                 map: this.map
    //             });

    //             this.map && this.map.setCenter(pos);
    //         }
    //     }
    // }

    initMap = (refs, lat, lng) => {

        if (mapSdk != 0) {
			setTimeout(() => {
				initMap(true, refs,  [{lat: lat, lng: lng}]);
			}, 1000)
			return;
		}
    }

    render() {
        return <div ref="map" style={{ width: "100%", height: "300px" }} id="fix-map"></div>
    }
}